import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { Layout } from 'src/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { getProductionTimeRangeLabel, ProductionTimeRange } from 'src/constants';
import CardTotalsMenu from './CardTotalsMenu';

type HomeTotalsCardGroupProps = {
  key: string;
  label: string;
  timeRange: ProductionTimeRange;
  setTimeRange: (x: ProductionTimeRange) => void;
  hasTimeRangeMenu?: boolean;
  hasAllTimeRangeLabel?: boolean;
  isMobile: boolean;
  children: React.ReactNode;
};

export default function HomeTotalsCardGroup({
  label,
  timeRange,
  setTimeRange,
  hasTimeRangeMenu,
  hasAllTimeRangeLabel,
  isMobile,
  children,
}: HomeTotalsCardGroupProps) {
  return (
    <Card sx={Layout.TotalsGroup}>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography sx={Layout.homeTotalsCardTitle}>{label}</Typography>
          </Box>
        }
        action={
          hasTimeRangeMenu ? (
            <CardTotalsMenu timeRange={timeRange} setTimeRange={setTimeRange} />
          ) : undefined
        }
      />
      {hasTimeRangeMenu && (hasAllTimeRangeLabel || timeRange !== ProductionTimeRange.ALL) && (
        <Typography sx={Layout.homeTotalsCardSubTitle}>
          {getProductionTimeRangeLabel(timeRange)}
        </Typography>
      )}
      <Box sx={Layout.TotalsCardWrapper({ isMobile })}>{children}</Box>
    </Card>
  );
}
